import { useQuery } from "@tanstack/react-query";

import { getClientsClientID } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { CLIENTS_QUERY_KEYS } from "./queryKeys";

export function useClientDetailQuery(clientID?: string) {
  return useQuery({
    queryKey: CLIENTS_QUERY_KEYS.detail(clientID!),
    queryFn: processResponse(() => getClientsClientID(clientID!)),
    enabled: !!clientID,
  });
}
